export var createPhoneApi = function (baseUrl, http) {
    var ticketsUrl = "".concat(baseUrl, "/tickets");
    var ticketUrl = function (id) { return "".concat(ticketsUrl, "/").concat(id); };
    var callsUrl = function (id) { return "".concat(ticketUrl(id), "/calls"); };
    var phoneNumbersUrl = "".concat(baseUrl, "/twilio/admin/numbers");
    var phoneUrl = "".concat(ticketsUrl, "/phone");
    var tokenUrl = "".concat(phoneUrl, "/token");
    var callUrl = "".concat(ticketsUrl, "/call");
    var invitationUrl = "".concat(callUrl, "/invitation");
    return {
        makeCallFromTicket: function (callFromTicketDto) {
            var ticketId = callFromTicketDto.ticketId;
            return http.post("".concat(callsUrl(ticketId)), callFromTicketDto);
        },
        getPhoneNumbers: function () {
            return http.get(phoneNumbersUrl);
        },
        getToken: function (ttlSeconds, refreshToken) {
            var params = new URLSearchParams();
            if (ttlSeconds) {
                params.append('ttlSeconds', ttlSeconds.toString());
            }
            if (refreshToken) {
                params.append('refreshToken', refreshToken.toString());
            }
            var query = params.toString() ? "?".concat(params.toString()) : '';
            return http.get("".concat(tokenUrl).concat(query));
        },
        terminateCurrentCall: function (currentCallDto) {
            var ticketId = currentCallDto.ticketId, callId = currentCallDto.callId;
            return http.post("".concat(ticketUrl(ticketId), "/calls/").concat(callId, "/terminate"), {});
        },
        inviteAgentToCurrentCall: function (addParticipantDto) {
            var ticketId = addParticipantDto.ticketId, callId = addParticipantDto.callId, invitedAgentId = addParticipantDto.invitedAgentId;
            return http.post("".concat(ticketUrl(ticketId), "/calls/").concat(callId, "/inviteAgent"), { invitedAgentId: invitedAgentId });
        },
        abortParticipantCall: function (addParticipantDto) {
            var ticketId = addParticipantDto.ticketId, callId = addParticipantDto.callId, invitedAgentId = addParticipantDto.invitedAgentId;
            return http.post("".concat(ticketUrl(ticketId), "/calls/").concat(callId, "/participants/").concat(invitedAgentId, "/abort"), {});
        },
        holdCurrentCall: function (currentCallDto) {
            var ticketId = currentCallDto.ticketId, callId = currentCallDto.callId;
            return http.post("".concat(ticketUrl(ticketId), "/calls/").concat(callId, "/hold"), {});
        },
        unholdCurrentCall: function (currentCallDto) {
            var ticketId = currentCallDto.ticketId, callId = currentCallDto.callId;
            return http.post("".concat(ticketUrl(ticketId), "/calls/").concat(callId, "/unhold"), {});
        },
        muteCurrentCaller: function (currentCallDto) {
            var ticketId = currentCallDto.ticketId, callId = currentCallDto.callId;
            return http.post("".concat(ticketUrl(ticketId), "/calls/").concat(callId, "/mute"), {});
        },
        unmuteCurrentCaller: function (currentCallDto) {
            var ticketId = currentCallDto.ticketId, callId = currentCallDto.callId;
            return http.post("".concat(ticketUrl(ticketId), "/calls/").concat(callId, "/unmute"), {});
        },
        joinCall: function (joinCallDto) {
            var ticketId = joinCallDto.ticketId, callId = joinCallDto.callId;
            return http.post("".concat(ticketUrl(ticketId), "/calls/").concat(callId, "/listen"), {});
        },
        getPhoneCall: function (getPhoneCallDto) {
            var ticketId = getPhoneCallDto.ticketId, callId = getPhoneCallDto.callId;
            return http.get("".concat(ticketUrl(ticketId), "/calls/").concat(callId));
        },
        getCallInvitationInfo: function (getCallInvitationDto) {
            var invitationClientKey = getCallInvitationDto.invitationClientKey;
            return http.get("".concat(invitationUrl, "?invitationClientKey=").concat(invitationClientKey));
        },
        transferCallToQueue: function (dto) {
            return http.post("".concat(callsUrl(dto.ticketId), "/").concat(dto.callId, "/transfer"), { queueId: dto.queueId });
        },
        warmTransferCallToQueue: function (dto) {
            return http.post("".concat(callsUrl(dto.ticketId), "/").concat(dto.callId, "/warmTransfer"), { queueId: dto.queueId });
        },
        makeCallFromTicketsList: function (callFromTicketsListDto) {
            return http.post("".concat(phoneUrl, "/outbound"), callFromTicketsListDto);
        },
        getIncomingCallData: function (key) {
            return http.get("".concat(callUrl, "/incomingClientCallData?incomingClientCallKey=").concat(key));
        },
        pausePhoneCallRecording: function (dto) {
            return http.post("".concat(callsUrl(dto.ticketId), "/").concat(dto.phoneCallId, "/pauseRecording"), {});
        },
        resumePhoneCallRecording: function (dto) {
            return http.post("".concat(callsUrl(dto.ticketId), "/").concat(dto.phoneCallId, "/resumeRecording"), {});
        },
        hardTransferCall: function (dto) {
            return http.post("".concat(callsUrl(dto.ticketId), "/").concat(dto.callId, "/transfer/hard"), { updatedSkillIds: dto.updatedSkillIds, locale: dto.locale });
        },
        softTransferCall: function (dto) {
            return http.post("".concat(callsUrl(dto.ticketId), "/").concat(dto.callId, "/transfer/soft"), { updatedSkillIds: dto.updatedSkillIds, locale: dto.locale });
        },
    };
};
//# sourceMappingURL=index.js.map